import { registrationViewSchema, type EditionSummary } from '@koderek/shared';
import { Loader, Stack, Text, Title } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { apiGet } from '../api/client';
import { ErrorAlert } from '../components/ErrorAlert';
import { UpcomingEditionPicker } from '../features/editions/UpcomingEditionPicker';
import { FamilyQrPanel } from '../features/qr/FamilyQrPanel';
import { t } from '../texts/pl';

/** US-601: kod QR rodziny na wejście – osobny ekran w menu (wcześniej panel na stronie edycji). */
export function FamilyQrPage() {
  return (
    <Stack gap="md" maw={720}>
      <Stack gap={4}>
        <Title order={1}>{t.qr.navTitle}</Title>
        <Text c="dimmed">{t.qr.intro}</Text>
      </Stack>
      {/* Na wejściu liczy się budynek – sama krótka nazwa miejsca (bez niej miasto). */}
      <UpcomingEditionPicker label={t.qr.whichEdition} optionLabel={(e) => e.placeName ?? e.city}>
        {(edition) => <EditionQr key={edition.slug} edition={edition} />}
      </UpcomingEditionPicker>
    </Stack>
  );
}

function EditionQr({ edition }: { edition: EditionSummary }) {
  const registration = useQuery({
    queryKey: ['registration', edition.slug],
    queryFn: () => apiGet(`/editions/${encodeURIComponent(edition.slug)}/registration`, registrationViewSchema),
  });
  if (registration.isError) return <ErrorAlert error={registration.error} />;
  if (!registration.data) return <Loader size="sm" aria-label="Ładowanie" />;
  // Kod odprawia całą rodzinę – każda osoba z konta jest uczestnikiem.
  const people = registration.data.people.map((p) => `${p.firstName} ${p.lastName}`);
  return <FamilyQrPanel edition={edition} people={people} />;
}
